/**
 * Environment Configuration
 *
 * Centralizes all environment variable access to prevent scattered
 * process.env calls throughout the codebase.
 *
 * Benefits:
 * - Single source of truth for environment variables
 * - Easy to mock in tests
 * - Type safety (can add JSDoc or TypeScript later)
 * - Clear documentation of all required env vars
 */

export const config = {
  // Google Maps Configuration
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  googleMapsMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,

  // AWS/Amplify Configuration
  // Note: This env variable doesn't follow VITE_ convention
  // It's set by Amplify CLI during deployment
  userPoolId: import.meta.env.AUTH_GAMMA6070A913_USERPOOLID,

  // Application Metadata
  commitId: import.meta.env.VITE_COMMIT_ID || 'dev',
  publicUrl: import.meta.env.BASE_URL || '/',

  // Environment Flags
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  isTest: import.meta.env.MODE === 'test',
};

/**
 * Validate required environment variables
 * Throws error if critical variables are missing
 */
export function validateConfig() {
  const required = {
    VITE_GOOGLE_MAPS_API_KEY: config.googleMapsApiKey,
    VITE_GOOGLE_MAPS_MAP_ID: config.googleMapsMapId,
  };

  const missing = Object.entries(required)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    console.warn(
      `Missing environment variables: ${missing.join(', ')}\n` +
      'Some features may not work correctly.'
    );
  }
}

// Validate on module load (development only)
if (config.isDevelopment) {
  validateConfig();
}
